import React from 'react';

import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from 'yup'
import { api } from '../../../../services/api';

import styles from './creation.module.scss'

interface Inputs {
    ID: any,
    CM_NOME: string,
    CM_PARENTE_ID: any
}

interface Props {
    data: any,
    changeContainerUser: any,
    onSubmitData: any,
    catgData: any
}

export const Forms: React.FC<Props> = ({ catgData, data, changeContainerUser, onSubmitData }) => {

    const SignupSchema = yup.object().shape({
        CM_NOME: yup.string()
            .required('Insira uma descrição'),
        CM_PARENTE_ID: yup.string()
    })

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm<Inputs>({ mode: "onChange", resolver: yupResolver(SignupSchema) })

    React.useEffect(() => {
        reset({
            CM_NOME: catgData.CM_NOME,
            CM_PARENTE_ID: catgData.CM_PARENTE_ID,
        })
    }, [catgData, reset])

    const [errorMessage, setErrorMessage] = React.useState(null)
    const [statusMessage, setStatusMessage] = React.useState(styles.errorMessageOff)

    function Save(data: Inputs) {

        if (data.CM_PARENTE_ID === '-1') {
            data.CM_PARENTE_ID = null
        }

        const method = catgData.ID !== "" ? "put" : "post"
        const id = catgData.ID !== "" ? `/${catgData.ID}` : ''

        api[method](`/categorias${id}`, {
            CM_NOME: data.CM_NOME,
            CM_PARENTE_ID: data.CM_PARENTE_ID
        })
            .then(function () {
                onSubmitData()
                reset({
                    ID: '',
                    CM_NOME: '',
                    CM_PARENTE_ID: '-1'
                })

                data = {
                    ID: '',
                    CM_NOME: '',
                    CM_PARENTE_ID: '-1'
                }
            })

            .then(function () {
                setTimeout(function () { setStatusMessage(styles.errorMessageOff) }, 300)
                changeContainerUser('catgButton')
            })
            .catch(function (error) {
                setErrorMessage(error.response.data)
                setTimeout(function () { setStatusMessage(styles.errorMessageOn) }, 300)
            })
    }

    function Cancel() {
        catgData.ID = ''

        reset({
            CM_NOME: '',
            CM_PARENTE_ID: '-1'
        })

        setTimeout(function () { setStatusMessage(styles.errorMessageOff) }, 300)
        changeContainerUser('catgButton')
    }

    const onSubmit = (data: Inputs) => {
        Save(data)
    }

    return (
        <form className={styles.form} action="" onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.flexContainer}>
                <label htmlFor="">Descrição</label>
                <input
                    {...register("CM_NOME")}
                    type="text" />
                {errors.CM_NOME && (<div className={styles.errorName}>{errors.CM_NOME.message}.</div>)}

                <label htmlFor="" className={styles.labelSelect}>Categoria Pai</label>
                <select
                    className={styles.select}
                    {...register("CM_PARENTE_ID")}
                    name="CM_PARENTE_ID" id="CM_PARENTE_ID">
                    <option value="-1"></option>
                    {
                        data.map((categoria: {
                            ID: number,
                            CM_NOME: string
                        }) => (
                            <option key={categoria.ID} value={categoria.ID}>{categoria.CM_NOME}</option>
                        )
                        )
                    }
                </select>
            </div>
            <div className={styles.buttonFlexContainer}>
                <div className={statusMessage}>
                    <h2>{errorMessage}</h2>
                </div>
                <div className={styles.buttonContainer}>
                    <button type="button" onClick={() => Cancel()}>Cancelar</button>
                    <button type="submit">Confirmar</button>
                </div>
            </div>
        </form>
    )
}